import { IssuesTab } from '../stores/IssuesTab';

export default function MobileMaterialIssue() {
  return <div className="p-3" data-testid="mobile-material-issue-page"><IssuesTab compact /></div>;
}
